<mat-card>
    <mat-card-header>
        <mat-card-title>Manutenção loja</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>
        <form [formGroup]="manutencaoForm">
            <div class="row mt-2">
                <div class="col-sm">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Descrição</mat-label>
                        <input type="text" matInput formControlName="descricao" required>
                    </mat-form-field>
                </div>

                <div class="col-3">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Previsão de retorno</mat-label>
                        <input type="text" matInput formControlName="previsaoRetorno" maxlength="19"
                            [textMask]="{mask: maskDate, guide:false}" required>
                    </mat-form-field>
                </div>

                <div class="col-auto mt-4">
                    <input type="checkbox" id="status" formControlName="status">
                    <label for="status" style="margin-left: 8px;">Status</label>
                </div>

            </div>
        </form>
    </mat-card-content>

    <mat-divider></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
        <button mat-flat-button color="primary" (click)="atualizar()">
            <mat-icon>check</mat-icon> Atualizar
        </button>
    </section>
</mat-card>